import { createStore } from 'vuex'

export default createStore({
    state: {
        // 保存router-view组件实例的引用
        routeViewComponent: null,
        isCalling: false,
        callingStatus: 3, //calling_status 1:1对1通话 2:room通话 3:正常状态 4:拨打电话 5:等待接听 6:被监视模式 7:等待离线人上线
        roomId: null,
        type: null,
        hangUpTime: null,
        needRefreshStatus: true,
        leaveRoomTime: null,
        toCallingUser: [], //打给谁
        inCallingUser: null,  //谁打的
        call_id: null, //拨打id,
        monitorRoom: null,//患者监视模式房间号,
        lastStatus: null, //保存来电之前的状态
        lastMonitorRoom: null,
        chatStatus: false,
        noticeStatus: false,
        loginid: "", // 账号
        password: "", // 密码
        code: "", // 验证码
        inCallingPage:false,
    },
    mutations: {
        saveCallingStatus(state, params) {
            state.isCalling = params.isCalling ? params.isCalling : false;
            state.callingStatus = params.callingStatus ? params.callingStatus : null;
            state.roomId = params.roomId ? params.roomId : null;
            state.type = params.type ? params.type : null;
            state.toCallingUser = params.toCallingUser ? params.toCallingUser : null;
            state.inCallingUser = params.inCallingUser ? params.inCallingUser : null;
            state.call_id = params.call_id ? params.call_id : null;
            state.monitorRoom = params.monitorRoom ? params.monitorRoom : null;
        },
        saveInCallingPage(state, status){
            state.inCallingPage = status;
        },
        saveLastStatus(state, params) {
            state.lastStatus = params.lastStatus ? params.lastStatus : null;
            state.lastMonitorRoom = params.lastMonitorRoom ? params.lastMonitorRoom : null;
        },
        saveHangUpTime(state) {
            state.hangUpTime = new Date()
        },
        saveLeaveRoomTime(state) {
            state.leaveRoomTime = new Date()
        },
        changeRefreshStatus(state, status) {
            state.needRefreshStatus = status;
        },
        saveChatStatus(state, status) {
            state.chatStatus = status;
        },
        saveNoticeStatus(state, status) {
            state.noticeStatus = status;
        },

        setLoginid(state, loginid) {
            state.loginid = loginid;
        },
        setPassword(state, password) {
            state.password = password;
        },
        setCode(state, code) {
            state.code = code;
        },
    },
    actions: {
        doMethods(context,params){
            context.state.routeViewComponent.doMethods(params);
        }
    },
    modules: {
    }
})
